var map = {
	"./cabinet_t4.png": "./src/assets/objectIcons/cabinet_t4.png",
	"./closure_t4.png": "./src/assets/objectIcons/closure_t4.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/objectIcons recursive ^\\.\\/.*_t4\\.png$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons ^\.\/.*_t4\.png$
// module id = ./src/assets/objectIcons recursive ^\.\/.*_t4\.png$
// module chunks = 1